import { Box, Text, Image } from "@chakra-ui/react";
import React from "react";
import { css } from "@emotion/react";

const QoreBanner = () => {
  return (
    <Box
      flex="1"
      css={css`
        width: calc(100% - 636px);
        flex-basis: calc(100% - 636px);
      `}
      bg="blue.100"
      position="fixed"
      right={0}
      h="full"
      display={{ base: "none", lg: "block" }}
      overflow="hidden"
      bgGradient="linear(to-b, rgba(0, 101, 255, 1), rgba(77, 147, 255, 1))"
    >
      <Box
        css={css`
          background-image: url("/assets/logo-pattern.svg");
          background-repeat: repeat-x;
          background-position: -72px 0;
        `}
        bgGradient="linear(to-b, rgba(153, 193, 255, 1), rgba(153, 193, 255, 0))"
        display="flex"
        justifyContent="center"
        flexDir="column"
        alignItems="center"
        h="full"
      >
        <Image
          src="/assets/new-illustration.svg"
          alt="Qore Platform"
          width="full"
          height="50%"
          objectFit="contain"
        />
        <Box
          css={css`
            max-width: 456px;
          `}
          textAlign="center"
          color="white"
        >
          <Text fontSize="28px" fontWeight="bold">
            Good colaboration tool for digitalizing your business
          </Text>
          <Text mt="5" fontSize="14px">
            Qore provides an environment for business analysts, developers, and
            other stakeholders to collaborate in building applications that are
            agile and flexible.
          </Text>
        </Box>
      </Box>
    </Box>
  );
};

export default QoreBanner;
